export const PXBanner = (function () {
	'use strict';

	var circle_size;
	var $banners;

	function init() {
		$banners = $('.pxblock--banner');
		if(!$banners.length > 0) return null;
		// circle_size = 3381;
		circle_size = ( $(window).width() * 1.5 < 3381 ) ? $(window).width() * 1.5 : 3381;

		events();
		videoButtons();
	}

	function setBanners() {

		circle_size = ( $(window).width() * 1.5 < 3381 ) ? $(window).width() * 1.5 : 3381;

		$banners.each( function() {
			var $t = $(this);

			// Primary
			if ( $t.hasClass('layout--copy-and-image') ) {
				$t.find('.background-image').each( function() {
					var $image = $(this);
					var height = $image.outerHeight();
					$image.css('clipPath', 'circle('+(circle_size)+'px at 50% '+(height - circle_size)+'px)');
				})
			}

			// refactor opportunity
			if (
				$t.hasClass('layout--half-copy') ||
				$t.hasClass('layout--half-copy-and-secondary') ||
				$t.hasClass('layout--only-copy')
			 ) {
				var height = $t.outerHeight();
				$t.find('.mask').css('clipPath', 'circle('+(circle_size)+'px at 50% '+(height - circle_size)+'px)');
			}

		});
	}

	function events() {
		setBanners();
		$(window).on('resize', setBanners);
	}

	function videoButtons() {
		$banners.each(function(){
			let $this = $(this);
			let $video = $this.find('video');
			let $button = $this.find('.video-js__start-btn');
			// console.log($video);
			$button.on('click', function(){
				$video.get(0).paused ? $video.get(0).play() : $video.get(0).pause();
				$( '.video-js__start-btn svg' ).toggle();
			});
		});
	}

	return {
		init: init,
	};
})();
